import { reactive, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import httpRequest from '@/request/index';
import { useRouter } from "vue-router";
import { showToast, showFailToast, showLoadingToast, closeToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const rePassword = ref(false);
    let forminput = reactive({
      fsubmit: 1,
      user_phone: "",
      user_pwd: ""
    });
    function user_login() {
      showLoadingToast({
        message: '登录中',
        forbidClick: true
      });
      httpRequest({
        method: "post",
        url: "?file=login",
        data: forminput
      }).then(res => {
        closeToast();
        console.log(res);
        if (res.state == 1) {
          if (rePassword.value) {
            localStorage.setItem('user_phone', forminput.user_phone);
            localStorage.setItem('user_pwd', forminput.user_pwd);
          }
          store.commit("login", res.token);
          showToast({
            message: "登录成功",
            onClose: function () {
              router.replace("/index");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
    }
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (store.state.isLogin) {
          router.replace("/index");
        }
      });
      var user_phone = localStorage.getItem('user_phone');
      if (user_phone) {
        forminput.user_phone = user_phone;
      }
      var user_pwd = localStorage.getItem('user_pwd');
      if (user_pwd) {
        rePassword.value = true;
        forminput.user_pwd = user_pwd;
      }
    });
    return {
      forminput,
      user_login,
      rePassword
    };
  }
};